import { render, staticRenderFns } from "./LocalizarPerguntaResposta.vue?vue&type=template&id=1e4e933d&scoped=true"
import script from "./LocalizarPerguntaResposta.vue?vue&type=script&lang=ts"
export * from "./LocalizarPerguntaResposta.vue?vue&type=script&lang=ts"
import style0 from "./LocalizarPerguntaResposta.vue?vue&type=style&index=0&id=1e4e933d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4e933d",
  null
  
)

export default component.exports